document.addEventListener('DOMContentLoaded', function() {
    // Desktop filters logic
    const desktopButtons = document.querySelectorAll('.group-filter__action .dropdown-menu button');
    
    desktopButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
            const filterType = this.getAttribute('data-filter-type');
            const filterValue = this.getAttribute('data-filter-value');
            if (filterType && filterValue) {
                const url = new URL(window.location.href);
                
                // Clear page when filtering to avoid issues if paginated?
                
                if (filterType === 'view') {
                    url.searchParams.set('view', filterValue);
                } else if (filterType === 'round') {
                    url.searchParams.set('round', filterValue);
                    url.searchParams.set('view', 'round');
                } else if (filterType === 'team') {
                    url.searchParams.set('f_team', filterValue);
                }
                
                window.location.href = url.toString();
            }
        });
    });
    
    // Reset Logic
    const resetBtns = document.querySelectorAll('.reset-btn');
    resetBtns.forEach(b => {
        b.addEventListener('click', () => {
             const url = new URL(window.location.href);
             url.search = ''; 
             window.location.href = url.toString();
        });
    });

    // Mobile specific logic for active state toggle
    const mobileMenus = document.querySelectorAll('.filter-step2 .dropdown-menu');
    mobileMenus.forEach(menu => {
        const btns = menu.querySelectorAll('button');
        btns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                // Ensure other buttons in this menu are not active
                btns.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
            });
        });
    });

    // Mobile Apply Logic
    const confirmBtn = document.querySelector('.filter-dropdown__action .confirm-btn');
    if (confirmBtn) {
        confirmBtn.addEventListener('click', () => {
            const url = new URL(window.location.href);
            
            // View
            const viewBtn = document.querySelector('.dropdown-content[data-option="view"] .dropdown-menu button.active');
            if (viewBtn) {
                const val = viewBtn.getAttribute('data-filter-value');
                if (val) url.searchParams.set('view', val);
            }
            
            // Round
            const roundBtn = document.querySelector('.dropdown-content[data-option="round"] .dropdown-menu button.active');
            if (roundBtn) {
                const val = roundBtn.getAttribute('data-filter-value');
                if (val) url.searchParams.set('round', val);
            }
            
            // Team
            const teamBtn = document.querySelector('.dropdown-content[data-option="team"] .dropdown-menu button.active');
            if (teamBtn) {
                const val = teamBtn.getAttribute('data-filter-value');
                if (val) url.searchParams.set('f_team', val);
            }
            
            window.location.href = url.toString();
        });
    }
});